import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      isSidebarMinimized: false,
      isLoading: false,
      openQuotation: false,
      openContract: false,
      openCompany: false,
      openContact: false,
    }
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },

    toggleQuotation() {
      this.openQuotation = !this.openQuotation
    },

    toggleContact() {
      this.openContact = !this.openContact
    },

    toggleCompany() {
      this.openCompany = !this.openCompany
    },

    toggleContract() {
      this.openContract = !this.openContract
    },

    showLoading() {
      this.isLoading = true
    },

    hideLoading() {
      this.isLoading = false
    },
  },
})
